export const AiChatBotMessageRef = 'ai-chatBot-messaging';
